//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

import { PageUtils } from "./helpers/page-utils";

function unlockBody() {
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
}

function lockBody() {
    PageUtils.bodyLockToggleOn();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
}

window.addEventListener('load', () => {
    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const toggleCTA = document.getElementById('toggleCTA');

    // Set scroll limit to 10% of viewport height
    let scrollLimit = window.innerHeight * 0.1;
    let navOpenScrollPosY = window.scrollY;

    // Update scroll limit on resize
    window.addEventListener('resize', () => {
        scrollLimit = window.innerHeight * 0.1;
    });

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    function toggleHamburger() {
        if (hamburger) {
            if (player.play) {
                if (player.hasEnded || player.isPlaying) {
                    player.reverse();
                } else {
                    player.play();
                }
            }
        }
    }

    function closeHamburger() {
        if (hamburger) {
            if (player.play) {
                player.reverse();
            }
        }
    }

    if (menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // Use desktop dropdown for all screen sizes
            if (siteHeader) {
                // Close recruitment dropdown if open
                if (siteHeader.dataset.recruitment === 'true') {
                    siteHeader.dataset.recruitment = 'false';
                    if (toggleCTA) {
                        toggleCTA.title = 'Open Recruitment Options';
                    }
                }

                const isOpening = siteHeader.dataset.dropdown === 'false';
                siteHeader.dataset.dropdown = isOpening ? 'true' : 'false';

                // Update button title
                menuToggleMobile.title = isOpening ? 'Close Menu' : 'Open Menu';

                toggleHamburger();
                startListening();
            }
        });
    }

    // Toggle CTA (recruitment dropdown) functionality
    if (toggleCTA) {

        toggleCTA.addEventListener('click', () => {
            // Unified logic for all screen sizes
            if (siteHeader) {
                // Toggle recruitment dropdown
                if (siteHeader.dataset.recruitment === 'true') {
                    siteHeader.dataset.recruitment = 'false';
                    toggleCTA.title = 'Open Recruitment Options';
                } else {
                    // Close desktop dropdown if open
                    if (siteHeader.dataset.dropdown === 'true') {
                        siteHeader.dataset.dropdown = 'false';
                        toggleHamburger(); // Reset hamburger animation
                    }

                    siteHeader.dataset.recruitment = 'true';
                    toggleCTA.title = 'Close Recruitment Options';
                }

                startListening();
            }
        });
    }



    function closeDesktopNav() {
        if (siteHeader.dataset.dropdown === 'true') {
            siteHeader.dataset.dropdown = 'false';
            closeHamburger();

            // Reset button title
            if (menuToggleMobile) {
                menuToggleMobile.title = 'Open Menu';
            }
        }
    }

    function closeRecruitmentDropdown() {
        if (siteHeader.dataset.recruitment === 'true') {
            siteHeader.dataset.recruitment = 'false';
            if (toggleCTA) {
                toggleCTA.title = 'Open Recruitment Options';
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeDesktopNav();
        closeRecruitmentDropdown();
    }

    function startListening() {
        // Update scroll position when dropdown opens (using ScrollSmoother if available)
        navOpenScrollPosY = window.smoother ? window.smoother.scrollTop() : window.scrollY;

        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
        window.addEventListener('keydown', keydownListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
        window.removeEventListener('keydown', keydownListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (siteHeader.dataset.open === 'false' && siteHeader.dataset.dropdown === 'false' && siteHeader.dataset.recruitment === 'false') {
            return; // Nothing is open, no need to close
        }

        // Use ScrollSmoother scroll position if available, otherwise use window.scrollY
        const currentScroll = window.smoother ? window.smoother.scrollTop() : window.scrollY;

        if (currentScroll >= (scrollLimit + navOpenScrollPosY) || currentScroll <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    const keydownListener = (event) => {
        if (event.key === 'Escape') {
            closeAllNavs();
            stopListening();
        }
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = (window.smoother ? window.smoother.scrollTop() : window.scrollY) + scrollLimit;
    setTimeout(() => {
        scrollPositive = (window.smoother ? window.smoother.scrollTop() : window.scrollY) + scrollLimit;
    }, 100);

    function navScrollCheck() {
        const scrollPos = window.smoother ? window.smoother.scrollTop() : window.scrollY;

        setTimeout(() => {
            const currentScroll = window.smoother ? window.smoother.scrollTop() : window.scrollY;

            if (scrollPos > currentScroll) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < currentScroll) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
        }, 50);
    }

    // set nav position on load
    setNavStyles(true);

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (siteHeader && docBody) {
            if (document.body.dataset.lightboxOpen === 'true') return;
            const wasDropdownOpen = siteHeader.dataset.dropdown === 'true';
            const currentScroll = window.smoother ? window.smoother.scrollTop() : window.scrollY;

            if (currentScroll > scrollLimit && !negScroll) {
                siteHeader.dataset.visible = 'false';
                docBody.dataset.navVisible = 'false';

                if (wasDropdownOpen) {
                    closeDesktopNav();
                }
            }
            else if (currentScroll > scrollLimit && negScroll) {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
            else {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';

                if (wasDropdownOpen) {
                    closeDesktopNav();
                }
            }
        }
    }


});